module.exports = __webpack_public_path__ + "static/img/icon4.1b55a508.svg";